import { render, staticRenderFns } from "./sold-tickets-modal.vue?vue&type=template&id=50138bf0&scoped=true"
import script from "./sold-tickets-modal.vue?vue&type=script&lang=js"
export * from "./sold-tickets-modal.vue?vue&type=script&lang=js"
import style0 from "./sold-tickets-modal.vue?vue&type=style&index=0&id=50138bf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50138bf0",
  null
  
)

export default component.exports